import styled from 'styled-components';

const INFO_BOX_HEIGHT = '160px';

export const ACCOUNT_ACTIVITY_SKELETON_HEIGHT = '210px';

export const AccountActivityPanel = styled.div`
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	border-radius: 0.5rem;
	padding: 0.5rem;
	background: ${({ theme }) => theme.v3.colors.white[0]};

	.info-box {
		display: flex;
		justify-content: center;
		align-items: center;
		height: ${INFO_BOX_HEIGHT};
		border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
		border-radius: 0.25rem;
		text-align: center;
	}

	.session {
		padding: 0.5rem;

		&-status {
			&:not(:last-child) {
				margin-bottom: 1rem;
			}
		}
	}
`;
